import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_CUSTOMER_FACING_NOTES_ERROR:
    'settings/digitalQuote/FETCH_CUSTOMER_FACING_NOTES_ERROR',
  FETCH_CUSTOMER_FACING_NOTES_SUCCESS:
    'settings/digitalQuote/FETCH_CUSTOMER_FACING_NOTES_SUCCESS',
  UPDATE_CUSTOMER_FACING_NOTES_ERROR:
    'settings/digitalQuote/UPDATE_CUSTOMER_FACING_NOTES_ERROR',
  UPDATE_CUSTOMER_FACING_NOTES_REQUEST:
    'settings/digitalQuote/UPDATE_CUSTOMER_FACING_NOTES_REQUEST',
  UPDATE_CUSTOMER_FACING_NOTES_SUCCESS:
    'settings/digitalQuote/UPDATE_CUSTOMER_FACING_NOTES_SUCCESS',
};

export const fetchCustomerFacingNotes = {
  error: () => ({
    type: types.FETCH_CUSTOMER_FACING_NOTES_ERROR,
  }),
  success: ({ customerFacingNotes }) => ({
    type: types.FETCH_CUSTOMER_FACING_NOTES_SUCCESS,
    payload: { customerFacingNotes },
  }),
};

export const updateCustomerFacingNotes = {
  error: notify(
    (error) => ({
      type: types.UPDATE_CUSTOMER_FACING_NOTES_ERROR,
      payload: error,
    }),
    "Can't update Customer-Facing Notes",
  ),
  request: ({ customerFacingNotes }) => ({
    type: types.UPDATE_CUSTOMER_FACING_NOTES_REQUEST,
    payload: { customerFacingNotes },
  }),
  success: notify(
    ({ customerFacingNotes }) => ({
      type: types.UPDATE_CUSTOMER_FACING_NOTES_SUCCESS,
      payload: { customerFacingNotes },
    }),
    'Success',
    'Customer-Facing Notes successfully updated',
  ),
};
